import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var fromHEX = function fromHEX(input) {
  return input.length === 7 ? [input.slice(1, 3), input.slice(3, 5), input.slice(5, 7)].map(function (x) {
    return parseInt(x, 16);
  }).reduce(function (acc, color) {
    return acc === undefined || isNaN(color) ? undefined : [].concat(_toConsumableArray(acc), [color]);
  }, []) : undefined;
};
export var fromRGBA = function fromRGBA(input) {
  return input.indexOf('(') === -1 || input.indexOf(')') === -1 ? undefined : input.split('(')[1].split(')')[0].split(',').map(function (y) {
    return y.trim();
  }).map(function (z) {
    return z.indexOf('.') !== -1 ? parseFloat(z) : parseInt(z, 10);
  }).reduce(function (acc, color) {
    return acc === undefined || isNaN(color) ? undefined : [].concat(_toConsumableArray(acc), [color]);
  }, []);
};
export var fromRGB = function fromRGB(input) {
  return input.indexOf('(') === -1 || input.indexOf(')') === -1 ? undefined : input.split('(')[1].split(')')[0].split(',').map(function (y) {
    return parseInt(y.trim(), 10);
  }).reduce(function (acc, color) {
    return acc === undefined || isNaN(color) ? undefined : [].concat(_toConsumableArray(acc), [color]);
  }, []);
};
export var fromHSVA = function fromHSVA(input) {
  var parsed = input.indexOf('(') === -1 || input.indexOf(')') === -1 ? undefined : input.split('(')[1].split(')')[0].split(',').map(function (y) {
    return y.trim();
  }).map(function (z) {
    return z.indexOf('.') !== -1 ? parseFloat(z) : parseInt(z, 10);
  }).reduce(function (acc, color) {
    return acc === undefined || isNaN(color) ? undefined : [].concat(_toConsumableArray(acc), [color]);
  }, []);
  if (parsed === undefined) {
    return undefined;
  }

  // https://en.wikipedia.org/wiki/HSL_and_HSV#From_HSV
  var _parsed = _slicedToArray(parsed, 4),
    hue = _parsed[0],
    saturation = _parsed[1],
    value = _parsed[2],
    alpha = _parsed[3];
  var normalizedSaturation = saturation / 100;
  var normalizedValue = value / 100;
  var C = normalizedValue * normalizedSaturation;
  var hueSixths = hue / 60;
  var X = C * (1 - Math.abs(hueSixths % 2 - 1));
  var blue1;
  var green1;
  var red1;
  if (hueSixths <= 1) {
    red1 = C;
    green1 = X;
    blue1 = 0;
  } else if (hueSixths <= 2) {
    red1 = X;
    green1 = C;
    blue1 = 0;
  } else if (hueSixths <= 3) {
    red1 = 0;
    green1 = C;
    blue1 = X;
  } else if (hueSixths <= 4) {
    red1 = 0;
    green1 = X;
    blue1 = C;
  } else if (hueSixths <= 5) {
    red1 = X;
    green1 = 0;
    blue1 = C;
  } else if (hueSixths <= 6) {
    red1 = C;
    green1 = 0;
    blue1 = X;
  } else {
    red1 = 0;
    green1 = 0;
    blue1 = 0;
  }
  var m = normalizedValue - C;
  var red = Math.round((red1 + m) * 255);
  var green = Math.round((green1 + m) * 255);
  var blue = Math.round((blue1 + m) * 255);
  return [red, green, blue, alpha];
};
export default (function (input) {
  if (input[0] === '#') {
    var colors = fromHEX(input);
    return colors === undefined ? undefined : colors;
  }
  if (input.slice(0, 4) === 'rgba') {
    var _colors = fromRGBA(input);
    return _colors === undefined ? undefined : _colors;
  }
  if (input.slice(0, 4) === 'hsva') {
    var _colors2 = fromHSVA(input);
    return _colors2 === undefined ? undefined : _colors2;
  }
  if (input.slice(0, 3) === 'rgb') {
    var _colors3 = fromRGB(input);
    return _colors3 === undefined || _colors3.length !== 3 ? undefined : _colors3;
  }
});
//# sourceMappingURL=fromString.js.map